module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-fr-2.a62caabd.png";